import { render, staticRenderFns } from "./PublishBtn.vue?vue&type=template&id=6d380060&scoped=true&"
import script from "./PublishBtn.vue?vue&type=script&lang=ts&"
export * from "./PublishBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d380060",
  null
  
)

export default component.exports